export default __webpack_public_path__ + "a9b72d7e7af57524b4fd48f7364313c6.png";